<div class="oa-sheet refuse-dialog">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            Reprovar #{{ proposal?.proposalNumber }} {{ proposal?.shortDescription }}?
            <span class="oa-sheet__subtitle">{{ proposal?.client?.name }} · {{ value }}</span>
        </h2>
        <button type="button" class="oa-icon-btn" mat-dialog-close aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body refuse-dialog__body">
        <p class="refuse-dialog__label" id="refuse-reason-label">
            Motivo <span class="refuse-dialog__optional">(opcional, aparece nos relatórios)</span>
        </p>
        <div class="oa-chip-row" role="group" aria-labelledby="refuse-reason-label">
            <button type="button" class="oa-chip oa-chip--toggle" *ngFor="let option of reasons"
                [attr.aria-pressed]="reasonType === option.value" (click)="pick(option.value)">
                <span class="oa-chip__label">{{ option.label }}</span>
            </button>
        </div>

        <mat-form-field appearance="outline" class="refuse-dialog__note">
            <mat-label>Observação (opcional)</mat-label>
            <textarea matInput rows="3" maxlength="1000" [(ngModel)]="reason"></textarea>
        </mat-form-field>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" mat-dialog-close>Cancelar</button>
        <button type="button" class="oa-btn oa-btn--danger" (click)="refuse()">
            <mat-icon>thumb_down</mat-icon>
            Reprovar
        </button>
    </footer>
</div>
